
define('text!fusion/ui/controls/fusion-kendogrid.html',[],function () { return '<div data-bind="attr: {id: instanceId}"></div>';});

